export default "__VITE_ASSET__DRaT$hNU__"